import * as React from 'react';
import * as _ from 'underscore';

import { ServerFilterClauses } from '../../../ts/helpers/ServerFilterClauses';
import { SiteRoleFilterHelper } from '../../../ts/helpers/SiteRoleFilterHelper';
import { SiteUserDefinition } from '../../../ts/models/ContentDefinitions';
import { SiteRoleOptionsResource } from '../../../ts/resources/SiteRoleOptions';
import { SiteRolesResource } from '../../../ts/resources/SiteRoles';
import { SiteUsers } from '../../../ts/resources/SiteUsers';
import { IStringValuedFilterClause } from '../../../ts/ServerApi/types/IFilterClause';
import { SiteRoles } from '../../../ts/ServerApi/types/ISiteRole';
import { ISelectFilterDefinition } from '../../../ts/services/FilterPanelService';
import { ServiceLocator } from '../../ServiceLocator';
import { isGroupSpace } from '../../state/SpaceInfo';
import { AdvancedFilterPanel, AdvancedFilterPanelProps, AdvancedFilterPanelScope } from './AdvancedFilterPanel';

export interface SiteUsersAdvancedFilterPanelProps extends AdvancedFilterPanelProps {}

export class SiteUsersAdvancedFilterPanel extends React.Component<SiteUsersAdvancedFilterPanelProps> {

  private siteRoleFilterDefinition: ISelectFilterDefinition<string>;
  private users: SiteUsers = undefined;
  private siteRoles: SiteRolesResource = undefined;
  private siteRoleOptionsResource: SiteRoleOptionsResource = undefined;

  public constructor(props: SiteUsersAdvancedFilterPanelProps) {
    super(props);
    this.users = ServiceLocator.get('SiteUsers');
    this.siteRoles = ServiceLocator.get('SiteRoles');
    this.siteRoleOptionsResource = ServiceLocator.get('SiteRoleOptionsResource');
  }

  public render() {
    return <AdvancedFilterPanel {...{...this.props, scopeReference: this.scopeRef}} />;
  }

  public componentDidMount() {
    this.updateSiteRoleCounts();
  }

  public componentDidUpdate(prevProps: SiteUsersAdvancedFilterPanelProps) {
    if (this.searchTerm(this.props) !== this.searchTerm(prevProps)) {
      this.updateSiteRoleCounts();
    }
  }

  private updateSiteRoleCounts = async () => {
    let query = SiteUserDefinition.getBasicQuery();
    if (isGroupSpace(this.props.spaceInfo)) {
      query = query.addFilter((ServerFilterClauses.serverFilterClauses.inGroup(this.props.spaceInfo.item.id)));
    }
    if (this.searchTerm(this.props)) {
      query = query.addFilter(this.props.mixedContentFilterMap.search);
    }
    const userCountsByRole = await this.users.getUserCountsBySiteRole(query);
    const allSiteRolesExceptGuest = _.without(this.siteRoles.allOptions(), SiteRoles.Guest);
    this.siteRoleFilterDefinition.options =
        SiteRoleFilterHelper.siteRoleOptions(allSiteRolesExceptGuest, this.siteRoleOptionsResource, userCountsByRole);
  }

  private scopeRef = (scope: AdvancedFilterPanelScope) => {
    this.siteRoleFilterDefinition = scope.filterDefinitions[0] as ISelectFilterDefinition<string>;
  }

  private searchTerm = (props: SiteUsersAdvancedFilterPanelProps) => {
    return (props.mixedContentFilterMap.search
      && (props.mixedContentFilterMap.search as IStringValuedFilterClause).value)
      || '';
  }
}
